export const INITIATORS = {
  WIDGET: 'widget',
};
